export default __webpack_public_path__ + "static/SR France - Origine - Note d'information-0c9d3653e9d5e29b565fe042e08d3379.pdf";